import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { useTranslate } from '@tolgee/react';
import { GetServerSideProps } from 'next';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Header from '@amf/shared/components/layout/Header';
import Menu from '@amf/shared/components/menu/Menu';
import { RefereeLicense } from '@amf/shared/data/Referee';
import { useState } from 'react';
import Container from '@amf/shared/components/layout/Container';
import RefereeList from '@amf/shared/components/referee/RefereeList';

import Meta from 'components/Meta';
import Layout from 'components/layout/Layout';
import { AppLinks } from 'utils/links';

interface RefereeListPageProps extends NavigationProps {}

function RefereeListPage({ navigation, partners }: RefereeListPageProps) {
  const { t } = useTranslate();
  const [license, setLicense] = useState<RefereeLicense | null>(null);

  return (
    <Layout navigation={navigation} partners={partners}>
      <Meta title={t('referee.list.title')} />
      <Header title={t('referee.list.title')} />
      <Menu<RefereeLicense | null>
        onChange={({ value }) => setLicense(value)}
        selected={{ id: license, title: license, value: license }}
        items={[
          {
            id: null,
            title: t(`referee.license.all`),
            value: null,
          },
          {
            id: RefereeLicense.SUPERLIGA_A,
            title: t(`referee.license.${RefereeLicense.SUPERLIGA_A}`),
            value: RefereeLicense.SUPERLIGA_A,
          },
          {
            id: RefereeLicense.SUPERLIGA_B,
            title: t(`referee.license.${RefereeLicense.SUPERLIGA_B}`),
            value: RefereeLicense.SUPERLIGA_B,
          },
          {
            id: RefereeLicense.SUPERLIGA_TRAINEE,
            title: t(`referee.license.${RefereeLicense.SUPERLIGA_TRAINEE}`),
            value: RefereeLicense.SUPERLIGA_TRAINEE,
          },
          {
            id: RefereeLicense.OS_A,
            title: t(`referee.license.${RefereeLicense.OS_A}`),
            value: RefereeLicense.OS_A,
          },
          {
            id: RefereeLicense.OS_B,
            title: t(`referee.license.${RefereeLicense.OS_B}`),
            value: RefereeLicense.OS_B,
          },
          {
            id: RefereeLicense.OS_C,
            title: t(`referee.license.${RefereeLicense.OS_C}`),
            value: RefereeLicense.OS_C,
          },
        ]}
      />
      <Container>
        <RefereeList license={license} prefixes={{ referee: AppLinks.referee }} />
      </Container>
    </Layout>
  );
}

export default RefereeListPage;

export const getServerSideProps: GetServerSideProps<RefereeListPageProps> = async ({
  locale,
  res,
}) => {
  res.setHeader('Cache-Control', 'max-age=0, s-maxage=10');

  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
  };
};
